import AppConfig from '../AppConfig';

import {
    INTEGRATION_PARTNER,
    CASE_TYPE_MAP, RECORD_DATA_TYPE,
    INTEGRATION_PARTNER_MAP as SHARED_PARTNER_MAP
} from '@demandproai/shared';


export const INTEGRATION_PARTNER_MAP = {
    [INTEGRATION_PARTNER.CASEPEER]: {
        ...SHARED_PARTNER_MAP[INTEGRATION_PARTNER.CASEPEER],
        baseURL: `https://${AppConfig.CasePeerBaseUrl}/api/v1`,
        tokenURL: `https://${AppConfig.CasePeerBaseUrl}/o/token/`,
        redirectURL: `https://${AppConfig.FeBaseUrl}/callback/casepeerauth`,
        introspectURL: `https://${AppConfig.CasePeerBaseUrl}/o/introspect/`,
        uiStyle: {
            bgColor: "#28d294",
            color: "var(--color-white)"
        }
    },
    [INTEGRATION_PARTNER.CHARTSQUAD]: {
        ...SHARED_PARTNER_MAP[INTEGRATION_PARTNER.CHARTSQUAD],
        uiStyle: {
            bgColor: "var(--color-white)",
            color: "var(--color-content)"
        }
    },
    [INTEGRATION_PARTNER.SMARTADVOCATE]: {
        ...SHARED_PARTNER_MAP[INTEGRATION_PARTNER.SMARTADVOCATE],
        uiStyle: {
            bgColor: "var(--color-white)",
            color: "var(--color-content)",
            renderText: () => (
                <><span className="text-brand-smart-advocate">Smart </span><span className="text-content">Advocate</span></>
            )
        }
    }
};

// case-insensitive lookup so partnerId casing drift from stored records still resolves to the right map entry
export const getPartnerConfig = (partnerId) => Object.values(INTEGRATION_PARTNER_MAP).find(
    (config) => config.key.toLowerCase() === String(partnerId).toLowerCase()
);

export const COMPANY_MODAL_KEYS = {
    ACTIVE: "active",
    CASE_VOLUME: "caseVolume",
    INACTIVE: "inactive",
    CREDIT: "credit",
    COST: "cost",
    RENEWAL_COMPANIES: "renewalCompanies",
    FAILED_CASES: "failedCases",
    PREVIOUS_FAILED_CASES: "previousFailedCasesModel",
    FAILED_RECORDS: "failedRecordsModel",
    RUNNING_CASES: "runningCaseModal",
    SUCCESSFUL_CASES: "successfulCaseModal",
    NON_SUCCESSFUL_CASES: "nonSuccessfulCaseModal",
    UNFULFILLED_RUNNING_CASES: "unfulfilledRunningCasesModal",
    LIMBO_CASES: "limboCasesModal",
    PERCENTILE_CASES: "percentileCasesModal",
    PROMPTS: "prompts",
    SIGNED_UP_YTD:"SUBSCRIBED",
    CANCELED_YTD: "CANCELED",
    CHAT_SESSIONS: "chatSessions",
    ROLLOVER_CREDITS: "rolloverCredits",
    ALACARTE_CREDITS: "alacarteCredits",
    ICD_DISABLED_CASES: "icdDisabledCasesModal"
};

export const COMPANY_MODAL_TITLES = {
  ACTIVE: "Active Companies",
  CASE_VOLUME: "Case Volume by Customer",
  INACTIVE: "Inactive Companies",
  CREDIT: "Credit Companies",
  COST: "Companies Cost",
  RENEWAL_COMPANIES: "Upcoming Contract Renewals",
  FAILED_CASES: "Failed Cases",
  FAILED_RECORDS: "Failed Records",
  PREVIOUS_FAILED_CASES: "Previously Failed Cases",
  RUNNING_CASES: "Running Cases",
  SUCCESSFUL_CASES: "Successful Cases",
  NON_SUCCESSFUL_CASES: "Non Successful Cases",
  UNFULFILLED_RUNNING_CASES: "Unfulfilled Running Cases",
  LIMBO_CASES: "Limbo Cases",
  PERCENTILE_CASES: "99 Percentile",
  SIGNED_UP: "Signed Up Company List",
  CANCELED: "Canceled Company List",
  PROMPTS: "Prompts",
  ROLLOVER_CREDITS: "Most Rollover Credits",
  ALACARTE_CREDITS: "Most À La Carte Credits",
  ICD_DISABLED_CASES: "ICD Code Disabled Cases",
};

export const CONCATENATION_POSITION = {
    PREPEND: "prepend",
    APPEND: "append",
};

export const POPOVER_PLACEMENT = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    LEFT_TOP: "left-top",
    LEFT_BOTTOM: "left-bottom",
    RIGHT_TOP: "right-top",
    RIGHT_BOTTOM: "right-bottom",
}

export const RECORD_FILE_CONFIG = {
  [RECORD_DATA_TYPE.DEPOSITION_DOC]: {
    title: "Deposition Document",
    defaultName: "Deposition Doc",
    uploadSuccessMessage: "Deposition document uploaded successfully",
    removeSuccessMessage: "Deposition document removed successfully",
  },
  [RECORD_DATA_TYPE.CURRICULUM_VITAE]: {
    title: "Curriculum Vitae",
    defaultName: "CV File",
    uploadSuccessMessage: "CV uploaded successfully",
    removeSuccessMessage: "CV removed successfully",
  },
  [RECORD_DATA_TYPE.OPPOSING_DISCOVERY]: {
    title: "Opposing Discovery",
    defaultName: "Opposing Discovery",
    uploadSuccessMessage: "Opposing Discovery uploaded successfully",
    removeSuccessMessage: "Opposing Discovery removed successfully",
  },
};

export const DISCOVERY_FOLLOW_UP_QUESTIONS = [
    "IDENTIFY each PERSON with information that supports YOUR answer to the preceding question.",
    "IDENTIFY all DOCUMENTS upon which YOU rely to support YOUR answer to the preceding question."
];

export const MEDICAL_BILL_FIELD = {
  PROVIDER_NAME: "medicalProviderName",
  TOTAL_AMOUNT: "totalBillAmount",
};

export const QUESTION_SECTION = {
    PREFERENCE: "PREFERENCE",
    GENERATED: "GENERATED",
};

export const QUESTION_SECTION_CONFIG = [
    { key: QUESTION_SECTION.PREFERENCE, title: "Preference Questions", emptyText: "No preference questions found." },
    { key: QUESTION_SECTION.GENERATED, title: "Generated Questions", emptyText: "No generated questions found." },
];

export {
    INTEGRATION_PARTNER,
    CASE_TYPE_MAP,
}
